<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="gw-space-y-4">
    <div class="gw-mb-4 gw-flex gw-items-center gw-gap-2">
      <input
        type="checkbox"
        class="gw-w-4 gw-h-4 gw-rounded gw-border-border-normal"
        formControlName="sandbox"
        id="plutech-sandbox"
      />
      <label
        for="plutech-sandbox"
        class="gw-text-sm gw-font-medium gw-text-text-primary"
      >
        {{ 'features.integrations.sandboxMode' | translate }}
      </label>
    </div>

    <div class="gw-mb-4">
      <label
        for="plutech-apiKey"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.apiKey' | translate }}
      </label>
      <input
        id="plutech-apiKey"
        type="text"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="apiKey"
        [placeholder]="'features.integrations.apiKeyPlaceholder' | translate"
      />
      <small
        *ngIf="form.get('apiKey')?.invalid && form.get('apiKey')?.touched"
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.apiKeyRequired' | translate }}
      </small>
    </div>

    <div class="gw-mb-4">
      <label
        for="plutech-apiSecret"
        class="gw-block gw-text-sm gw-font-medium gw-text-text-primary gw-mb-2"
      >
        {{ 'features.integrations.apiSecret' | translate }}
      </label>
      <input
        id="plutech-apiSecret"
        type="text"
        class="gw-w-full gw-px-4 gw-py-2 gw-border gw-border-border-normal gw-rounded-lg gw-bg-background-elevation-1 focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-primary"
        formControlName="apiSecret"
        [placeholder]="'features.integrations.apiSecretPlaceholder' | translate"
      />
      <small
        *ngIf="form.get('apiSecret')?.invalid && form.get('apiSecret')?.touched"
        class="gw-text-status-negative gw-text-sm gw-mt-1 gw-block"
      >
        {{ 'features.integrations.apiSecretRequired' | translate }}
      </small>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        [title]="'common.actions.cancel' | translate"
        variant="secondary"
        type="button"
        (click)="close()"
      ></gatewee-button>
      <gatewee-button
        [title]="
          submitting
            ? ('common.actions.saving' | translate)
            : ('common.actions.save' | translate)
        "
        variant="primary"
        type="submit"
        [disabled]="form.invalid || submitting"
      ></gatewee-button>
    </div>
  </form>
</div>
